var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 58,
    viewBox: "0 0 161 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.474 1.09289L100.555 2.95295C100.413 3.24063 100.281 3.35885 99.9767 3.35885H96.4772L95.5209 5.30299H97.9209C98.2256 5.30299 98.3268 5.43435 98.1836 5.74305L97.4375 7.2642C97.2956 7.55188 97.1642 7.6701 96.8595 7.6701H94.3741L93.3403 9.78369H96.9251C97.2299 9.78369 97.3297 9.91505 97.1879 10.2237L96.2867 12.0838C96.1449 12.3715 95.9964 12.4897 95.6917 12.4897H89.1158C88.811 12.4897 88.7099 12.3584 88.8531 12.0497L94.2126 1.05874C94.3544 0.771056 94.5029 0.652832 94.8076 0.652832H101.215C101.52 0.652832 101.62 0.788132 101.474 1.09289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.502 3.57304L108.405 5.80616C107.83 6.98841 107.19 7.76737 106.196 8.08921L105.657 11.9617C105.643 12.114 105.57 12.2546 105.453 12.353C105.336 12.4513 105.184 12.4996 105.032 12.4872H102.536C102.3 12.4872 102.237 12.4031 102.259 12.1824L102.811 8.25997H102.574L100.713 12.0812C100.571 12.3689 100.424 12.4872 100.119 12.4872H97.5996C97.2948 12.4872 97.195 12.3558 97.3369 12.0471L102.695 1.05617C102.837 0.768492 102.985 0.650269 103.29 0.650269H107.72C109.781 0.652896 110.532 1.48178 109.502 3.57304ZM105.075 3.10014L103.427 6.48661H104.239C104.593 6.48661 104.772 6.31716 104.944 5.97956L106.093 3.61507C106.264 3.27616 106.138 3.10802 105.831 3.10802L105.075 3.10014Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.766 9.64849L108.16 8.83668C108.302 8.55031 108.433 8.43209 108.737 8.43209H111.342C111.645 8.43209 111.746 8.56345 111.605 8.87083L111.21 9.69972C111.04 10.0386 111.166 10.2068 111.473 10.2068H111.947C112.302 10.2068 112.481 10.0386 112.651 9.69972L113.407 8.14441C113.578 7.8055 113.499 7.58613 113.11 7.58613H111.961C109.847 7.58613 109.356 6.60487 110.29 4.67781L111.049 3.10149C111.812 1.51202 112.709 0.648987 114.417 0.648987H117.072C119.135 0.648987 119.885 1.47787 118.857 3.57438L118.501 4.30212C118.359 4.58848 118.211 4.70802 117.907 4.70802H115.302C114.998 4.70802 114.898 4.57666 115.04 4.26796L115.401 3.52315C115.572 3.18555 115.445 3.0161 115.138 3.0161H114.917C114.563 3.0161 114.367 3.18555 114.212 3.52315L113.555 4.91032C113.4 5.24923 113.462 5.4686 113.851 5.4686H114.991C117.103 5.4686 117.618 6.44855 116.661 8.37692L115.807 10.1188C115.026 11.7082 114.163 12.5699 112.456 12.5699H109.547C107.484 12.5739 106.749 11.7463 107.766 9.64849Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.345 0.974665L124.268 11.9656C124.186 12.2874 124.049 12.491 123.728 12.491H121.327C121.091 12.491 121.028 12.407 121.105 12.1705L121.536 10.8845H119.626L118.806 12.1705C118.661 12.407 118.52 12.491 118.281 12.491H115.677C115.374 12.491 115.283 12.2887 115.508 11.9656L123.149 0.974665C123.312 0.736902 123.468 0.652832 123.706 0.652832H127.122C127.361 0.652832 127.407 0.736902 127.345 0.974665ZM120.94 8.59357H122.444L123.183 6.31052L124.186 3.85934H123.847L122.44 6.31052L120.94 8.59357Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.164 0.974665L133.087 11.9656C133.005 12.2874 132.868 12.491 132.548 12.491H130.146C129.91 12.491 129.847 12.407 129.924 12.1705L130.355 10.8845H128.445L127.624 12.1705C127.48 12.407 127.339 12.491 127.099 12.491H124.495C124.19 12.491 124.108 12.2887 124.326 11.9656L131.967 0.974665C132.13 0.736902 132.286 0.652832 132.523 0.652832H135.938C136.178 0.652832 136.224 0.736902 136.164 0.974665ZM129.759 8.59357H131.263L132.002 6.31052L133.003 3.85934H132.666L131.258 6.31052L129.759 8.59357Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.928 12.0497L139.287 1.05874C139.428 0.771056 139.577 0.652832 139.881 0.652832H142.4C142.705 0.652832 142.805 0.784191 142.663 1.09289L138.534 9.53017H141.78C142.085 9.53017 142.186 9.66153 142.043 9.97023L141.026 12.0838C140.884 12.3715 140.736 12.4897 140.431 12.4897H134.193C133.882 12.4897 133.776 12.3544 133.928 12.0497Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5346 30.3995C32.3174 30.3995 32.9519 29.765 32.9519 28.9822C32.9519 28.1994 32.3174 27.5648 31.5346 27.5648C30.7518 27.5648 30.1172 28.1994 30.1172 28.9822C30.1172 29.765 30.7518 30.3995 31.5346 30.3995Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1986 30.3995C37.9814 30.3995 38.616 29.765 38.616 28.9822C38.616 28.1994 37.9814 27.5648 37.1986 27.5648C36.4158 27.5648 35.7812 28.1994 35.7812 28.9822C35.7812 29.765 36.4158 30.3995 37.1986 30.3995Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8705 30.3995C43.6533 30.3995 44.2879 29.765 44.2879 28.9822C44.2879 28.1994 43.6533 27.5648 42.8705 27.5648C42.0877 27.5648 41.4531 28.1994 41.4531 28.9822C41.4531 29.765 42.0877 30.3995 42.8705 30.3995Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.939 21.8321L106.38 15.7134C106.066 15.9538 105.725 16.1566 105.363 16.3176C103.918 19.2653 102.69 22.3168 101.102 25.195C100.923 25.5161 100.702 25.812 100.445 26.0751L103.804 34.1104L105.877 39.0719H116.146L108.939 21.8321Z",
    fill: "url(#paint0_linear_633_33407)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0563 21.8321L77.4974 15.7134C77.1832 15.9538 76.842 16.1566 76.4806 16.3176C75.0357 19.2653 73.8074 22.3168 72.2193 25.195C72.0402 25.5161 71.8194 25.812 71.5625 26.0751L74.9214 34.113L76.9943 39.0745H87.2693L80.0563 21.8321Z",
    fill: "url(#paint1_linear_633_33407)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4925 21.8321L91.9335 15.7134C91.6196 15.9541 91.2783 16.1569 90.9168 16.3176C89.4718 19.2653 88.2436 22.3168 86.6568 25.195C86.4777 25.516 86.2568 25.812 86 26.0751L89.3602 34.1104L91.4331 39.0719H101.702L94.4925 21.8321Z",
    fill: "url(#paint2_linear_633_33407)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.738 0.782913L128.812 53.2246H139.08L161.004 0.782913H150.738Z",
    fill: "url(#paint3_linear_633_33407)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.357 15.0065L118.671 42.9574H75.3853L71.0938 53.2245H114.378H119.06H124.645L140.624 15.0065H130.357Z",
    fill: "url(#paint4_linear_633_33407)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4301 0.782913H64.1643L46.5318 42.9575H16.1849H16.1836L27.8418 15.0723H17.5747L5.91647 42.9575L1.62362 53.2246L0 57.1076L11.8881 53.2246H11.8921H51.0309H52.5061L74.4301 0.782913Z",
    fill: "url(#paint5_linear_633_33407)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.773 15.0052L108.92 21.8334L103.787 34.1129L101.711 39.0744H91.4453L98.6544 21.8334L101.508 15.0052H111.773Z",
    fill: "url(#paint6_linear_633_33407)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.125 39.0744H105.859L115.922 15.0065H126.189L116.125 39.0744Z",
    fill: "url(#paint7_linear_633_33407)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.345 15.0052L94.4918 21.8334L89.3596 34.1129L87.2841 39.0744H77.0156L84.2234 21.8334L87.0792 15.0052H97.345Z",
    fill: "url(#paint8_linear_633_33407)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5894 0.782913L72.6427 15.0053L69.7896 21.836L56.6641 53.2246H66.9312L74.9218 34.113L80.0554 21.836L88.8566 0.782913H78.5894Z",
    fill: "url(#paint9_linear_633_33407)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.738 0.75264L128.812 53.1943H139.078L161.004 0.75264H150.738Z",
    fill: "url(#paint10_linear_633_33407)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.357 14.9752L118.671 42.9274H75.3853L71.0938 53.1945H114.378H119.06H124.645L140.623 14.9752H130.357Z",
    fill: "url(#paint11_linear_633_33407)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4301 0.75264H64.1643L46.5318 42.9259H16.1836L27.8405 15.042H17.5747L5.91647 42.9259H5.91516L1.6223 53.1943H1.62361L0 57.0773L11.8881 53.1943H11.8907H51.0309H52.5061L74.4301 0.75264Z",
    fill: "url(#paint12_linear_633_33407)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.773 14.9752L108.92 21.8033L103.787 34.0829L101.711 39.0431H91.4453L98.6544 21.8033L101.508 14.9752H111.773Z",
    fill: "url(#paint13_linear_633_33407)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.125 39.0444H105.859L115.922 14.9752H126.189L116.125 39.0444Z",
    fill: "url(#paint14_linear_633_33407)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.345 14.9752L94.4918 21.8033L89.3582 34.0829L87.2828 39.0431H77.0156L84.2234 21.8033L87.0792 14.9752H97.345Z",
    fill: "url(#paint15_linear_633_33407)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5894 0.75264L72.6427 14.975L69.7896 21.8058L56.6641 53.1943H66.9299L74.9218 34.0827L80.0554 21.8058L88.8552 0.75264H78.5894Z",
    fill: "url(#paint16_linear_633_33407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_33407",
    x1: 80.1751,
    y1: -26.3469,
    x2: 128.994,
    y2: 74.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_633_33407",
    x1: 56.7542,
    y1: -15.0368,
    x2: 105.573,
    y2: 86.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_633_33407",
    x1: 68.4621,
    y1: -20.6879,
    x2: 117.281,
    y2: 80.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_633_33407",
    x1: 317.353,
    y1: 23.6344,
    x2: 57.1501,
    y2: 28.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00F1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_633_33407",
    x1: 305.493,
    y1: 30.6384,
    x2: 45.2893,
    y2: 35.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_633_33407",
    x1: 329.939,
    y1: 23.126,
    x2: 69.7353,
    y2: 28.2096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_633_33407",
    x1: 329.933,
    y1: 22.5795,
    x2: 69.7301,
    y2: 27.6631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#33E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_633_33407",
    x1: 329.925,
    y1: 22.8619,
    x2: 69.7208,
    y2: 27.9455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_633_33407",
    x1: 329.927,
    y1: 22.2971,
    x2: 69.7238,
    y2: 27.3807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_633_33407",
    x1: 329.913,
    y1: 21.9805,
    x2: 69.7095,
    y2: 27.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_633_33407",
    x1: 327.583,
    y1: 26.8487,
    x2: 63.2952,
    y2: 27.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00F1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_633_33407",
    x1: 327.583,
    y1: 33.9489,
    x2: 63.2949,
    y2: 34.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_633_33407",
    x1: 327.581,
    y1: 28.7127,
    x2: 63.2934,
    y2: 28.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_633_33407",
    x1: 327.585,
    y1: 26.8554,
    x2: 63.2974,
    y2: 27.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#33E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_633_33407",
    x1: 327.571,
    y1: 26.866,
    x2: 63.2828,
    y2: 27.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_633_33407",
    x1: 327.584,
    y1: 26.8449,
    x2: 63.2963,
    y2: 27.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_633_33407",
    x1: 327.576,
    y1: 26.8001,
    x2: 63.2886,
    y2: 26.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FFC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b76f5a035a7667b21a0a4d90bb1f5797.svg";
export { ForwardRef as ReactComponent };